import { Col } from '../grid';
export default Col;


//////////////////
// WEBPACK FOOTER
// /Users/niko/Work/sketch/antd-pro/ant-design-pro-site/scaffold/node_modules/_antd@3.0.2@antd/es/col/index.js
// module id = 491
// module chunks = 0